import "./services.css";

import React from "react";
import { Link } from "react-router-dom";

import { ROUTES, SERVICES } from "../../data/content";
import PageMeta from "../general/PageMeta";

//One service (Banking, Vitality, ...): photo background, title & photo collage on the left, details on the right
const ServicePage = ({ service }) => {
  const firstParagraph = service.intro[0] || service.list[0] || "";
  const others = SERVICES.filter((s) => s.path !== service.path);

  return (
    <React.Fragment>
      <PageMeta
        title={service.menuName || service.name}
        description={firstParagraph.length > 160 ? `${firstParagraph.slice(0, firstParagraph.lastIndexOf(" ", 157))}...` : firstParagraph}
      />
      <section
        className={"service-page"}
        style={{ backgroundImage: `url(${service.background})` }}
      >
        <div className={"service-page-inner container"}>
          <div className={"service-page-side"}>
            <h1 className={"service-page-title"}>{service.title}</h1>
            <div
              className={`service-collage ${service.images.length === 2 ? "is-pair" : ""}`}
              aria-hidden={"true"}
            >
              {service.images.map((image) => (
                <img
                  key={image}
                  src={image}
                  alt={""}
                  width={480}
                  height={480}
                />
              ))}
            </div>
          </div>

          <div className={"service-page-content"}>
            {service.intro.map((paragraph) => (
              <p key={paragraph.slice(0, 30)}>{paragraph}</p>
            ))}
            {service.list.length > 0 ? (
              <React.Fragment>
                <p>{service.listHeading}</p>
                <ul>
                  {service.list.map((item) => (
                    <li key={item.slice(0, 30)}>{item}</li>
                  ))}
                </ul>
              </React.Fragment>
            ) : null}
            <Link
              to={ROUTES.CONTACT}
              className={"btn btn-light service-page-cta"}
            >
              Contact us today!
            </Link>
          </div>
        </div>
      </section>

      {/* Links to the other services so visitors don't have to go back to Our Services */}
      <nav
        className={"service-others"}
        aria-label={"Other services"}
      >
        <div className={"container"}>
          <h2 className={"service-others-title"}>Our other services</h2>
          <ul className={"service-others-list"}>
            {others.map((other) => (
              <li key={other.path}>
                <Link to={other.path}>{other.name}</Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default ServicePage;
